export default "__VITE_ASSET__Ds8V8Z57__"